<template>
    <div v-if="dataSource && dataSourceType === 'InnerDocument'"
        :key="document.id"
        class="p-relative"
    >

        <Toolbar v-on:toolbar-button-click="onToolbarClick"  />
        <DocumentPanel :document-info="dataSource.Data.Object" />

        <div class="d-flex after-tabs-part-wrapper">
            <v-tabs
                v-model="tab"
                background-color="transparent"
                slider-size="3"
                class="tab-selector-panel"
                mobile-breakpoint="0"
            >
                <v-tabs-slider color="#E43958"></v-tabs-slider>

                <v-tab 
                    v-for="item in pages"
                    :key="document.id + item.FormId"
                    @click="onTabClicked(item.FormId)"
                >
                    <template v-if="item.Count < 0">
                        {{ $t(item.Name) }}
                    </template> 
                    <template v-else>
                        {{ $t(item.Name) }}
                        <span class="count" id="attachCounter">{{item.Count}}</span>
                    </template>   
                </v-tab>

            </v-tabs>
            
            <div
                v-if="isViewMode && document.Version && (document.RegState === 0 || document.RegState === 3 || document.RegState === 5 || document.RegState === 6)"
                class="after-tabs-part"
            >
                <v-doc-version-chip :id="document.id" :text="$t('Версии')" />
            </div>

        </div>

        <v-tabs-items
            v-model="tab"
            class="tab-content-panel"
        >
            <v-tab-item 
                v-for="item in pages"
                :key="document.id + item.FormId"
            >
                <template v-if="item.FormId == document.id">
                    <v-form class="wrapperForm" ref="form" lazy-validation>
                        <v-row dense>
                            <v-col cols="12" sm="12" md="6" class="section-wrapper">
                                
                                <!--Секция Сведения о регистрации-->
                                <v-card flat v-if="isRegistered">
                                    <v-card-text>
                                        <div class="form-box-title">{{$t("Сведения_о_регистрации")}}</div>

                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Журнал_регистрации")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div class="onlyReadData">{{ document.Counter ? document.Counter.Name : '' }}</div>
                                            </v-col>
                                        </v-row>

                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Исходящий_номер,_дата")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div class="onlyReadData">{{ concatedRegistrationData  }}</div>
                                            </v-col>
                                        </v-row>

                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Регистратор")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div class="onlyReadData">
                                                    <v-workplace-chip :id="document.Card.RegistratorWorkplaceId" :name="document.Card.RegistratorName" />
                                                </div>
                                            </v-col>
                                        </v-row>

                                    </v-card-text>
                                </v-card>

                                <!--Секция Реквизиты документа-->
                                <v-card flat>
                                    <v-card-text>
                                        <div class="form-box-title">{{$t("Реквизиты_документа")}}</div>

                                        <!--поле Номер проекта (всегда просмотр)-->
                                        <v-row no-gutters v-if="!document.is_new_record">
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Номер_проекта")}}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <div class="onlyReadData">{{ document.Card.DraftNumber }}</div>
                                            </v-col>
                                        </v-row>
                                        
                                        <!--поле Тип внешнего контроля (только для ОРД)-->
                                        <!-- <v-row no-gutters v-if="isORD">
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Тип_внешнего_контроля")}}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{document.Card.OuterControlType ? document.Card.OuterControlType.Value : $t("не_указано")}}
                                                </div>
                                                <v-autocomplete
                                                    v-else
                                                    :value="document.Card.OuterControlType"
                                                    @input="update({ property: 'Data.Object.Document.Card.OuterControlType', value: $event })"
                                                    :items="GetReference(1027)"
                                                    :item-text="item => $refLocale(item, $i18n.locale)"
                                                    item-value="id"
                                                    return-object
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="requiredRule"
                                                    append-icon="fas fa-chevron-down"
                                                >
                                                </v-autocomplete>
                                            </v-col>
                                        </v-row> -->

                                        <!--поле Номенклатура-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Номенклатура")}}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{document.Nomenclature ? `${document.Nomenclature.Code} ${document.Nomenclature.Header}` : $t("не_указано")}}
                                                </div>
                                                <v-select
                                                    v-else
                                                    :value="document.NomenclatureId != guidEmpty ? document.NomenclatureId : null"
                                                    @input="onNomenclatureInput($event)"
                                                    :items="nomenclatures"
                                                    :item-text="item => `${item.Code} ${item.Header}`"
                                                    item-value="id"
                                                    return-object
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="requiredRule"
                                                    append-icon="fas fa-chevron-down"
                                                    :menu-props="{ bottom: true, offsetY: true }"
                                                >
                                                    <template v-slot:prepend-item>
                                                        <v-list-item>
                                                            <v-list-item-content>
                                                                <v-text-field 
                                                                    :placeholder="$t('Поиск')"
                                                                    class="mb-2 autocomplete-search"
                                                                    hide-details
                                                                    dense
                                                                    clearable
                                                                    autofocus
                                                                    v-model="nomenclatureSearch"
                                                                >
                                                                </v-text-field>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </template>
                                                </v-select>
                                            </v-col>
                                        </v-row>

                                        <!--поле Тип документа-->
                                        <!-- <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{ $t("Тип_документа") }}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{ document.Card.DocumentType ? document.Card.DocumentType.Value : $t("не_указано") }}
                                                </div>
                                                <v-select
                                                    v-else
                                                    :value="document.Card.DocumentType"
                                                    @input="update({ property: 'Data.Object.Document.Card.DocumentType', value: $event})"
                                                    :items="documentTypeItems"
                                                    :item-text="item => $refLocale(item, $i18n.locale)"
                                                    item-value="id"
                                                    return-object
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="requiredRule"
                                                    append-icon="fas fa-chevron-down"
                                                    :menu-props="{ bottom: true, offsetY: true }"
                                                >
                                                    <template v-slot:prepend-item>
                                                        <v-list-item>
                                                            <v-list-item-content>
                                                                <v-text-field 
                                                                    :placeholder="$t('Поиск')"
                                                                    class="mb-2 autocomplete-search"
                                                                    hide-details
                                                                    dense
                                                                    clearable
                                                                    autofocus
                                                                    v-model="documentTypeSearch"
                                                                >
                                                                </v-text-field>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </template>
                                                </v-select>
                                            </v-col>
                                        </v-row> -->

                                        <!--поле Вид внутреннего документа-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{ $t("Вид_внутреннего_документа") }}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <div v-if="isViewMode || !document.is_new_record" class="onlyReadData">
                                                    {{ document.DocumentTemplateType ? document.DocumentTemplateType.Value : $t("не_указано") }}
                                                </div>
                                                <v-select
                                                    v-else
                                                    :value="document.DocumentTemplateType"
                                                    @input="updateSource({ property: 'Data.Object.Document.DocumentTemplateType', value: $event});
                                                            updateSource({ property: 'Data.Object.Document.TemplateId', value: '00000000-0000-0000-0000-000000000000' });
                                                            updateSource({ property: 'Data.Object.Document.Template', value: null })"
                                                    :items="documentTemplateTypeItems"
                                                    :item-text="item => $refLocale(item, $i18n.locale)"
                                                    item-value="id"
                                                    return-object
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="requiredRule"
                                                    append-icon="fas fa-chevron-down"
                                                    :menu-props="{ bottom: true, offsetY: true }"
                                                >
                                                    <template v-slot:prepend-item>
                                                        <v-list-item>
                                                            <v-list-item-content>
                                                                <v-text-field 
                                                                    :placeholder="$t('Поиск')"
                                                                    class="mb-2 autocomplete-search"
                                                                    hide-details
                                                                    dense
                                                                    clearable
                                                                    autofocus
                                                                    v-model="documentTemplateTypeSearch"
                                                                >
                                                                </v-text-field>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </template>
                                                </v-select>
                                            </v-col>
                                        </v-row>

                                        <!--поле Шаблон документа-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{ $t("Шаблон_документа") }}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <div class="icon-click-row-group icrg-align-center">
                                                    <div v-if="!isViewMode && document.is_new_record" @click="onTemplateSelect">
                                                        <v-icon small v-tooltip.left-center="">
                                                            fas fa-edit
                                                        </v-icon>
                                                    </div>
                                                    <div class="onlyReadData">
                                                        {{ sourceTemplate?.Name?.[$t.locale == 'kk' ? 'kk-KZ' : 'ru-RU'] ?? $t("Типовой") }}
                                                    </div>
                                                </div>
                                            </v-col>
                                        </v-row>

                                        <!--поле Характер вопроса-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Характер_вопроса")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{ document.Card.QuestCharacter ? document.Card.QuestCharacter.Value : $t("не_указано") }}
                                                </div>
                                                <v-select
                                                    v-else
                                                    :value="document.Card.QuestCharacter"
                                                    @input="update({ property: 'Data.Object.Document.Card.QuestCharacter', value: $event })"
                                                    :items="questCharacterItems"
                                                    :item-text="item => $refLocale(item, $i18n.locale)"
                                                    item-value="id"
                                                    return-object
                                                    hide-details
                                                    outlined
                                                    dense
                                                    append-icon="fas fa-chevron-down"
                                                    :menu-props="{ bottom: true, offsetY: true }"
                                                >
                                                    <template v-slot:prepend-item>
                                                        <v-list-item>
                                                            <v-list-item-content>
                                                                <v-text-field 
                                                                    :placeholder="$t('Поиск')"
                                                                    class="mb-2 autocomplete-search"
                                                                    hide-details
                                                                    dense
                                                                    clearable
                                                                    autofocus
                                                                    v-model="questCharacterSearch"
                                                                >
                                                                </v-text-field>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </template>
                                                </v-select>
                                            </v-col>
                                        </v-row>

                                        <!--поле Язык документа-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Язык_документа")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">

                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{ document.Card.Languages ? documentLanguages.map((x) => x.Value).join(', ') : $t("не_указано") }}
                                                </div>

                                                <v-autocomplete
                                                    v-else
                                                    v-model="documentLanguages"
                                                    :items="GetReference(1000)"
                                                    :item-text="item => $refLocale(item, $i18n.locale)"
                                                    item-value="id"
                                                    multiple
                                                    return-object
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="multipleRule"
                                                    append-icon="fas fa-chevron-down"
                                                >
                                                </v-autocomplete>

                                            </v-col>
                                        </v-row>

                                        <!--поле Тип носителя-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Тип_носителя")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">

                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{document.Card.CarrierType ? document.Card.CarrierType.Value : $t("не_указано")}}
                                                </div>
                                                <v-autocomplete
                                                    v-else
                                                    :value="document.Card.CarrierType"
                                                    @input="update({ property: 'Data.Object.Document.Card.CarrierType', value: $event })"
                                                    :items="GetReference(1024)"
                                                    :item-text="item => $refLocale(item, $i18n.locale)"
                                                    item-value="id"
                                                    return-object
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="requiredRule"
                                                    append-icon="fas fa-chevron-down"
                                                >
                                                </v-autocomplete>
                                            </v-col>
                                        </v-row>

                                        <!--поле Количество ЛПЭ-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{ $t("Количество_листов/приложений") }}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">

                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{`${document.Card.ListCount}/${document.Card.AttachCount}`}}
                                                </div>
                                                <div class="more-inputs-in-row" v-else>
                                                    <v-text-field
                                                        :value="document.Card.ListCount"
                                                        @input="update({ property: 'Data.Object.Document.Card.ListCount', value: $event })"
                                                        hide-details
                                                        required
                                                        outlined
                                                        dense
                                                        type="number"
                                                        :rules="integerNotNull"
                                                        class="cust-inputnumber"
                                                        min="0"
                                                    >
                                                    </v-text-field>
                                                    <span>/</span>
                                                    <v-text-field
                                                        :value="document.Card.AttachCount"
                                                        @input="update({ property: 'Data.Object.Document.Card.AttachCount', value: $event })"
                                                        hide-details
                                                        required
                                                        outlined
                                                        dense
                                                        type="number"
                                                        :rules="integerRule.concat(requiredRule)"
                                                        class="cust-inputnumber"
                                                        min="0"
                                                    >
                                                    </v-text-field>
                                                </div>
                                            </v-col>
                                        </v-row>

                                    </v-card-text>
                                </v-card>

                            </v-col>

                            <v-col cols="12" sm="12" md="6" class="section-wrapper">

                                <DocumentStatusCard
                                    v-if="!document.is_new_record && isRegistered" 
                                    :controlInfo="controlInfo"
                                />

                                <!--Секция Исполнитель/Автор-->
                                <!-- <v-card flat>
                                    <v-card-text>
                                        <div class="form-box-title">{{ $t("Исполнитель/Автор_документа") }}</div>

                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Исполнитель")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div class="icon-click-row-group icrg-align-center">                                                    
                                                    <div v-if="!isViewMode" @click="onExecuterSelect">
                                                        <v-icon small v-tooltip.left-center="selectExecuterTooltip">
                                                            fas fa-edit
                                                        </v-icon>
                                                    </div>
                                                    <div class="onlyReadData">
                                                        <v-workplace-chip 
                                                            v-if="document.Card.ExecuterName" 
                                                            :id="document.Card.ExecuterWorkplaceId" 
                                                            :name="document.Card.ExecuterName" 
                                                            :canDelete="!isViewMode"                                                            
                                                            :delFunc="onRemoveExecuter"
                                                        />
                                                    </div>
                                                    <div class="chipAreaNoData d-flex align-center pl-1" v-if="!document.Card.ExecuterName && !isViewMode">
                                                        <v-select-members-chip                                            
                                                            target-type="Member"
                                                            @on-select="onSelecExecuterChip"
                                                            :items-params="membersExecuterSelectParams"
                                                            :required="true"
                                                        /> 
                                                    </div>
                                                </div>
                                            </v-col>
                                        </v-row>

                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Телефон_исполнителя")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{ document.Card.Phone ? document.Card.Phone : $t("не_указано") }}
                                                </div>
                                                <v-text-field
                                                    v-else
                                                    :value="document.Card.Phone"
                                                    @input="update({ property: 'Data.Object.Document.Card.Phone', value: $event })"
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="requiredRule"
                                                >
                                                </v-text-field>
                                            </v-col>
                                        </v-row>

                                    </v-card-text>
                                </v-card> -->

                                <!--Секция Адресат-->
                                <v-card v-if="isAddresseVisible">
                                    <v-card-text>
                                        <div class="form-box-title">{{ $t("Адресат") }}</div>

                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Кому")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div class="icon-click-row-group icrg-align-center">

                                                    <div v-if="!isViewMode" @click="onAddresseeSelect">
                                                        <v-icon small v-tooltip.left-center="selectAddresseeTooltip">
                                                            fas fa-edit
                                                        </v-icon>
                                                    </div>
                                                    
                                                    <template v-if="isAddresseeRequired">
                                                        <div class="onlyReadData">
                                                            <v-workplace-chip v-if="document.Card.Addressee" :id="document.Card.Addressee.Id" :name="document.Card.Addressee.Name" :canDelete="!isViewMode" :delFunc="onRemoveAddressee" />
                                                            <div v-else-if="!isViewMode" class="chipAreaNoData d-flex align-center pl-1">
                                                                <v-select-members-chip target-type="Member" @on-select="onAddresseeSelectChip" :items-params="addresseeSelectParams" :required="true" />
                                                            </div>
                                                        </div>
                                                    </template>
                                                    <div v-else class="onlyReadData">
                                                        <v-workplace-chip v-if="document.Card.Addressee" :id="document.Card.Addressee.Id" :name="document.Card.Addressee.Name" :canDelete="!isViewMode" :delFunc="onRemoveAddressee" />
                                                        <v-select-members-chip v-else-if="!isViewMode" target-type="Member" @on-select="onAddresseeSelectChip" :items-params="addresseeSelectParams" :required="false" />
                                                    </div>

                                                </div>
                                            </v-col>
                                        </v-row>

                                    </v-card-text>
                                </v-card>

                                <!--Секция Кем создано-->
                                <v-card flat v-if="isViewMode">
                                    <v-card-text>
                                        <div class="form-box-title">{{ $t("Кем_создано") }}</div>
                                        
                                        <!--поле Подготовил-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Подготовил")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div class="onlyReadData">
                                                    <v-employee-chip :id="document.AuthorId" :name="document.AuthorName" />
                                                </div>
                                            </v-col>
                                        </v-row>

                                        <!--поле Дата создания-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Дата_создания")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div class="onlyReadData">{{ formatDate(document.CreateDate) }}</div>
                                            </v-col>
                                        </v-row>

                                    </v-card-text>
                                </v-card>

                            </v-col>
                            
                            <v-col cols="12" sm="12" md="12" class="section-wrapper">
                                
                                <!--Секция Краткое содержание-->
                                <v-card flat>
                                    <v-card-text>
                                        <div class="form-box-title">{{$t("Краткое_содержание")}}</div>

                                        <v-row class="full-width-row" no-gutters>
                                            <v-col cols="12" sm="12" md="2">
                                                <label class="f-label">{{$t("Краткое_содержание")}}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="10">
                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{document.Theme}}
                                                </div>
                                                <v-textarea v-else
                                                    :value="document.Theme"
                                                    @input="update({ property: 'Data.Object.Document.Theme', value: $event })"
                                                    rows="3"
                                                    no-resize
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="requiredRule"
                                                >
                                                </v-textarea>
                                            </v-col>
                                        </v-row>

                                    </v-card-text>
                                </v-card>

                                <!--Секция Кому адресовано-->
                                <!-- <v-card flat>
                                    <v-card-text>
                                        <div class="form-box-title">{{$t("Кому_адресовано")}}</div>

                                        <v-row class="full-width-row" no-gutters>
                                            <v-col cols="12" sm="12" md="2">
                                                <label class="f-label">{{$t("Получатели")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="10">
                                                <div class="icon-click-row-group">
                                                    <div v-if="!isViewMode" @click="onRecipientsSelect">
                                                        <v-icon small v-tooltip.left-center="selectRecipientsTooltip">
                                                            fas fa-edit
                                                        </v-icon>
                                                    </div>
                                                    <div class="onlyReadData more-per-lab-wrap">                                                        
                                                        <template v-if="isViewMode && (!document.Card.Recipients || document.Card.Recipients.length === 0)">{{ $t("Не_указано") }}</template>
                                                        <template v-for="recipient in document.Card.Recipients">

                                                            <v-enterprise-chip
                                                                v-if="recipient.ContractorType === 0"
                                                                :key="'en' + recipient.Id"
                                                                :name="recipient.Name"
                                                                :canDelete="!isViewMode"
                                                                :id="recipient.Id"
                                                                :delFunc="onRemoveRecipient"
                                                            />

                                                            <v-workplace-chip
                                                                v-else
                                                                :key="recipient.Id"
                                                                :id="recipient.Id"
                                                                :name="recipient.Name"
                                                                :is-employee="recipient.IsEmployee"
                                                                :canDelete="!isViewMode"                                                                
                                                                :delFunc="onRemoveRecipient"
                                                            />

                                                        </template>
                                                        <v-select-members-chip   
                                                            v-if="!isViewMode"
                                                            target-type="Member"
                                                            @on-select="onSelectRecipientChip"
                                                            :items-params="membersRecipientSelectParams"
                                                        />
                                                    </div>
                                                </div>
                                            </v-col>
                                        </v-row>

                                    </v-card-text>
                                </v-card> -->

                            </v-col>

                        </v-row>
                    </v-form>
                </template>
                
                <!--<template v-else-if="item.FormId == 'TextDocument'">
                    <RicheditTab/>
                </template>-->

                <template v-else-if="item.FormId == 'Control'">
                    <ControlTab
                        :document="document"
                        :ref="item.FormId"
                    />
                </template>

                <template v-else-if="item.FormId == 'RouteParams'">
                    <RouteParamsTab
                        :isViewMode="isViewMode"
                        :readonly="dataSource.Data.Object.ProcessInfoReadOnly"
                    />
                </template>

                <template v-else-if="item.FormId == 'Requisites'">
                    <RequisitesTab
                        :editable="!isViewMode && dataSource.Data.Object.Status == 0"
                        :scheme="document.Template.DesignScheme"
                    />
                </template>

                <template v-else>
                    <component
                        :is="$mapComponent(item.FormId)"
                        :ref="item.FormId"
                        :id="document.id"
                    />
                </template>                

            </v-tab-item>

        </v-tabs-items>
    </div>
</template>

<script>
import _ from 'lodash'
import sys from '@/services/system';
import { mapActions, mapGetters } from 'vuex';
import i18n from '@/i18n'

import Toolbar from '@/components/documents/Toolbar.vue';
import DocumentPanel from '@/components/documents/DocumentPanel.vue';
import DocumentStatusCard from '@/components/documents/DocumentStatus';
import ControlTab from '@/components/documents/tabs/static/Control';
import RouteParamsTab from '@/components/documents/tabs/static/RouteParams';
import RicheditTab from '@/components/documents/tabs/richedit';
import RequisitesTab from '@/components/document-templates/RequisitesTab.vue';

import { httpAPI } from "@/api/httpAPI";

export default {
    name: "InnerCard",
    components: { 
        Toolbar,
        DocumentPanel,
        DocumentStatusCard,
        ControlTab,
        RouteParamsTab,
        RicheditTab,
        RequisitesTab
    },
    asyncComputed: {
        documentTypeItems: {
            async get () {
                let items = Array.from(await this.$store.dispatch('documents/references/getReference', { id: 1001 }));

                if (this.documentTypeSearch)
                    return items.filter(i => sys.checkSearch(i.Value, this.documentTypeSearch) || i.id == this.document?.Card?.DocumentType?.id);
                else
                    return items;
            },
            default: [],
            watch: ['documentTypeSearch']
        },
        documentTemplateTypeItems: {
            async get () {
                let items = Array.from(await this.$store.dispatch('documents/references/getReference', { id: 1041 }));

                if (this.documentTemplateTypeSearch)
                    return items.filter(i => sys.checkSearch(i.Value, this.documentTemplateTypeSearch) || i.id == this.document?.Card?.DocumentTemplateType?.id);
                else
                    return items;
            },
            default: [],
            watch: ['documentTemplateTypeSearch']
        },
        questCharacterItems: {
            async get () {
                let items = Array.from(await this.$store.dispatch('documents/references/getReference', { id: 1003 }));

                if (this.questCharacterSearch)
                    return items.filter(i => sys.checkSearch(i.Value, this.questCharacterSearch) || i.id == this.document?.Card?.QuestCharacter?.id);
                else
                    return items;
            },
            default: [],
            watch: ['questCharacterSearch']
        },
        nomenclatures : {
            async get() {
                if (this.nomenclatureSearch) {                
                    return (await this.$store.dispatch('documents/references/getNomenclatures', { forDepartment: false }))
                        .map(x => ({ id: x[0], Code: x[1], Header: x[2] }))
                        .filter(i => sys.checkSearch(`${i.Code} ${i.Header}`, this.nomenclatureSearch) || i.id == this.nomenclature?.id);
                }
                else
                    return (await this.$store.dispatch('documents/references/getNomenclatures', { forDepartment: false }))
                        .map(x => ({ id: x[0], Code: x[1], Header: x[2] }));
            },
            default: [],
            watch: ['nomenclatureSearch']
        },
        sourceTemplate: {
            async get () {
                if (this.document?.TemplateId == null || this.document.TemplateId == this.guidEmpty)
                    return null;

                var templateResponse = await httpAPI({
                    url: `api/document-templates/${this.document.TemplateId}`,
                    method: 'GET',
                    headers: {'isCommon': false }
                });
                
                return templateResponse?.data?.Payload?.Data?.Object;
            },
            default: null,
            watch: ['document.TemplateId']
        }
    },
    computed: {
        ...mapGetters('documents/references', ['GetReference']),
        ...mapGetters('global/actionsource', { controlInfo: 'getControlInfo', dataSource: 'getDataSource', dataSourceType: 'getDataSourceType', isCommon: 'isDataSourceCommon' }),
        ...mapGetters({ 
            requiredRule: 'getRequiredRule',
            multipleRule: 'getMultipleRule',
            integerRule: 'getIntegerRule',
            integerNotNull: 'getIntegerNotNullRule'
        }),
        ...mapGetters('global/auth', { userInfo: 'getUserInfo'}),
        documentLanguages: {
            get: function() {
                return this.document.Card.Languages?.data_list ?? [];
            },
            set: function(value) {
                if (this.document.Card.Languages != null)
                    this.updateSource({ property: 'Data.Object.Document.Card.Languages.data_list', value });
                else
                    this.updateSource({ property: 'Data.Object.Document.Card.Languages', value: { data_list: value } });
            }
        },
        isViewMode() {
            return this.dataSource?.Data?.FormId === "0201031";
        },
        document() {
            return this.dataSource?.Data?.Object?.Document;
        },
        pages() {
            let pages = 
            [
                { Count: -1, FormId: this.document?.id, Name: "Карточка" },
                
            ];

            /*if (!this.document.is_new_record && this.dataSource.Data.Object.Status == 0) {
                pages.push({ Count: -1, FormId: "TextDocument", Name: i18n.t("Текст_документа") });
            }*/

            if (this.document.Template) {
                pages.push({ Count: -1, FormId: "Requisites", Name: "Реквизиты_шаблона" });
            }

            if ((!this.isViewMode || this.document?.ProcessInfo != null) &&
                this.document?.RegState !== 1 && !this.isProtocol)
            {
                pages.push({ Count: -1, FormId: "RouteParams", Name: "Маршрут" });
            }

            if (this.isORD && this.isRegistered)
                pages.push({ Count: -1, FormId: "Control", Name: "Контроль" });
            
            pages = pages.concat(this.dataSource?.Data?.Object?.Pages ?? []);

            //ЭКБ НПА
            if (this.document?.EECBActMetadata != null)
                pages.push({ Count: -1, FormId: "GovermentRegistration", Name: i18n.t("Государственная_регистрация") });

            return pages;
        },
        isRegistered(){
            return this.document?.RegState === 1 || this.document?.RegState === 4; 
        },
        isORD() {
            return this.document?.Card.TypeC4 === 1;
        },
        concatedRegistrationData() {
            let result = i18n.t("Не_указано");

            if (this.document.Card.RegNumber?.length)
                result = `№ ${this.document.Card.RegNumber}`;

            if (this.document.Card.RegDate)
                result += ` ${this.$t("от_время")} ${this.formatDate(this.document.Card.RegDate)} г.`;

            return result;
        },
        selectNomenclatureTooltip(){
            return i18n.t("Выбрать_номенклатуру");
        },
        selectExecuterTooltip(){
            return this.$t("Выбрать_исполнителя");
        },
        selectRecipientsTooltip(){
            return this.$t("Выбрать_получателей");
        },
        selectAddresseeTooltip() {
            return this.$t("Выбрать_получателя");
        },
        guidEmpty() {
            return sys.guidEmpty();
        },
        membersExecuterSelectParams(){
            return {
                includeInner: true,
                includeOuter: this.isORD === true,
                multiple: false,
                selected: [ this.document.Card.ExecuterWorkplaceId ]
            };
        },
        membersRecipientSelectParams(){
            return {
                multiple: true,
                includeInner: true,
                includeOuter:  this.isCommon,
                includeOuterEnterprises: this.isORD,
                includeExecutersGroups: true,
                selected: [ ...this.document.Card.Recipients.map(x => x.Id) ]
            }
        },
        addresseeSelectParams() {
            return {
                includeInner: true,
                includeOuter: false,
                multiple: false,
                selected: [ this.document.Card.Addressee?.Id ]
            };
        },
        isAddresseVisible() {
            return [3, 4, 6, 100].includes(this.document?.DocumentTemplateType?.id);
        },
        isAddresseeRequired() {
            return [3, 4, 6].includes(this.document?.DocumentTemplateType?.id);
        }
    },
    data() {
        return {
            tab: null,
            questCharacterSearch: "",
            documentTypeSearch: "",
            documentTemplateTypeSearch: "",
            nomenclatureSearch: "",
            protocolTypeSearch: "",
        }
    },
    methods: {
        ...mapActions('global/actionsource', { updateSource: 'updateDataSource' }),
        onTabClicked (formId) {
            if (this.$refs[formId])
                this.$refs[formId][0]?.update();
        },
        async onToolbarClick (event, button) {
            let actions = Reflect.ownKeys(this.$store._actions).filter(i => i.includes('global/actionsource/')).map(i => {return i.split('/')[2]})

            // проверяем, есть ли реализованый метод в хранилище
            if (!actions.includes(button.Action)) {
                this.$notify.alert(`Действие_${button.Action}_не_реализовано.`);
                return;
            }

            // чтобы позже свалидировать форму, нужно убедиться, что компонент карточки попал в DOM
            if (button.Action === 'Edit' && this.document.Template)
                this.tab = 0;
            
            // если это не сохранение, валидация не нужна
            if (!['Save', 'SaveAndClose'].includes(button.Action)) {
                await this.$store.dispatch(`global/actionsource/${button.Action}`, {event, button});
                return;
            }

            let validate_result = this.$refs.form[0]?.validate();

            // стандартная валидация
            if (!validate_result || (this.isAddresseeRequired && this.document.Card.Addressee == null)) {
                this.$notify.alert(this.$t("Не_заполнены_обязательные_поля"));
                return;
            }

            // валидация по реквизитам
            if (this.document.Template && !this.validateTemplate()) {
                this.$notify.alert(this.$t("Не_заполнены_обязательные_реквизиты_шаблона"));
                return;
            }

            await this.$store.dispatch(`global/actionsource/${button.Action}`, {event, button});
        },
        formatDate (source) {
            return this.$moment(source).format('DD.MM.YYYY');
        },
        async onNomenclatureSelect (){
            try {
                let selected = await this.$store.dispatch('dialogs/selectNomenclature/open', null);
                this.updateSource({ property: 'Data.Object.Document.Nomenclature', value: { Code: selected[1], Header: selected[2] } });
                this.updateSource({ property: 'Data.Object.Document.NomenclatureId', value: selected[0] });
            }
            catch (ex) {
                console.log(ex);
            }
        },
        async onExecuterSelect (){
            try {
                let selectMemberParams =  { 
                    title: i18n.t("Выбор_исполнителя"),
                    includeInner: true,
                    includeOuter: this.isORD === true,
                    multiple: false,
                    selected: [ this.document.Card.ExecuterWorkplaceId ]
                }
                let { workplaceId, employeeId, name, contacts } = await this.$store.dispatch('global/dialogs/selectMembersNew/open', selectMemberParams);                
                this.updateSource({ property: 'Data.Object.Document.Card.ExecuterName', value: name });
                this.updateSource({ property: 'Data.Object.Document.Card.ExecuterWorkplaceId', value: workplaceId });
                this.updateSource({ property: 'Data.Object.Document.Card.ExecuterId', value: employeeId });

                let phone = contacts?.find(contact => { return contact.type === "phone"; }) ?? null;
                this.updateSource({ property: 'Data.Object.Document.Card.Phone', value: phone?.value ?? null });
            }
            catch (ex) {
                console.log(ex);
            }
        },
        async onRecipientsSelect () {
            try {
                let selectMemberParams =  { 
                    title:"Выбор_получателей",
                    multiple: true,
                    includeInner: true,
                    includeOuter:  this.isCommon,
                    includeOuterEnterprises: this.isORD,
                    includeExecutersGroups: true,
                    selected: [ ...this.document.Card.Recipients.map(x => x.Id) ]
                }
                let recipients = await this.$store.dispatch('global/dialogs/selectMembersNew/open', selectMemberParams);
                this.updateSource(
                {
                    property: 'Data.Object.Document.Card.Recipients',
                    value: recipients.map(recipient => 
                        ({
                            ContractorType: recipient.type, Id: recipient.type === 1 ? recipient.workplaceId : recipient.enterprise,
                            IsEmployee: recipient.type === 1,
                            Name: recipient.name
                        }))
                });
            }
            catch (ex) {
                console.log(ex);
            }
        },
        onNomenclatureInput(event) {
            this.updateSource({ property: 'Data.Object.Document.Nomenclature', value: { Code: event.Code, Header: event.Header } });
            this.updateSource({ property: 'Data.Object.Document.NomenclatureId', value: event.id });
        },
        update: _.debounce(function (object) {            
            this.updateSource(object);
        }, 250),
        onRemoveExecuter() {
            this.updateSource({ property: 'Data.Object.Document.Card.ExecuterName', value: null });
            this.updateSource({ property: 'Data.Object.Document.Card.ExecuterWorkplaceId', value: '00000000-0000-0000-0000-000000000000' });
            this.updateSource({ property: 'Data.Object.Document.Card.ExecuterId', value: '00000000-0000-0000-0000-000000000000' });                
            this.updateSource({ property: 'Data.Object.Document.Card.Phone', value: null });
        },
        onSelecExecuterChip(e){
            this.updateSource({ property: 'Data.Object.Document.Card.ExecuterName', value: e.value.name });
            this.updateSource({ property: 'Data.Object.Document.Card.ExecuterWorkplaceId', value: e.value.workplaceId });
            this.updateSource({ property: 'Data.Object.Document.Card.ExecuterId', value: e.value.employeeId });

            let phone = e.value.contacts?.find(contact => { return contact.type === "phone"; }) ?? null;
            this.updateSource({ property: 'Data.Object.Document.Card.Phone', value: phone?.value ?? null });
        },
        onSelectRecipientChip(e){
            let recipients = JSON.parse(JSON.stringify(this.dataSource.Data.Object.Document.Card.Recipients));
            recipients.push({ 
                ContractorType: e.value.type, Id: e.value.type === 1 ? e.value.workplaceId : e.value.enterprise,
                IsEmployee: e.value.type === 1,
                Name: e.value.name
            });

            this.updateSource({ property: 'Data.Object.Document.Card.Recipients', value: recipients});
        },
        onRemoveRecipient(id) {
            let recipients = JSON.parse(JSON.stringify(this.dataSource.Data.Object.Document.Card.Recipients));
            this.updateSource({ property: 'Data.Object.Document.Card.Recipients', value: recipients.filter(x => x.Id != id)});
        },
        async onTemplateSelect() {
            let dlgResult = await this.$store.dispatch('global/dialogs/templateSelect/open');

            if (dlgResult.cancel)
                return;
            
            //если выбрали типовой шаблон
            if (dlgResult.templateId == null) {
                if (this.document.TemplateId != '00000000-0000-0000-0000-000000000000') {                    
                    this.$notify.confirm(
                        this.$t('Заменить_шаблон_в_документе_вопрос'),
                        async () =>
                        {
                            this.updateSource({ property: 'Data.Object.Document.TemplateId', value: '00000000-0000-0000-0000-000000000000' });
                            this.updateSource({ property: 'Data.Object.Document.DocumentTemplateType', value: dlgResult.documentType });
                            this.updateSource({ property: 'Data.Object.Document.Template', value: null });
                        }
                    );
                    return;
                }
                
                this.updateSource({ property: 'Data.Object.Document.TemplateId', value: '00000000-0000-0000-0000-000000000000' });
                this.updateSource({ property: 'Data.Object.Document.DocumentTemplateType', value: dlgResult.documentType });
                this.updateSource({ property: 'Data.Object.Document.Template', value: null });
                return;
            }

            var templateResponse = await httpAPI({
                url: `api/document-templates/${dlgResult.templateId}`,
                method: 'GET',
                headers: {'isCommon': false }
            });
            
            let template = templateResponse?.data?.Payload?.Data?.Object;

            if (!template)
                return;

            let onApplyTemplate = async () => {
                let templateToDocument = { id: this.document.id, TemplateId: dlgResult.templateId, Requisites: template.Requisites, DesignScheme: template.DesignScheme };
                this.updateSource({ property: 'Data.Object.Document.TemplateId', value: dlgResult.templateId });
                this.updateSource({ property: 'Data.Object.Document.DocumentTemplateType', value: dlgResult.documentType });
                this.updateSource({ property: 'Data.Object.Document.Template', value: templateToDocument });
            };

            if (this.document.TemplateId != '00000000-0000-0000-0000-000000000000') {
                this.$notify.confirm(
                    this.$t('Заменить_шаблон_в_документе_вопрос'),
                    async () =>
                    { 
                        await onApplyTemplate();
                    }
                );
                return;
            }

            await onApplyTemplate();
        },
        async onAddresseeSelect() {
            try
            {
                let selectMemberParams =
                { 
                    title:"Выбор_адресата",
                    ...this.addresseeSelectParams
                };

                let addresseeResult = await this.$store.dispatch('global/dialogs/selectMembersNew/open', selectMemberParams);
                let addressee = { ContractorType: 1, Id: addresseeResult.workplaceId, IsEmployee: true, Name: addresseeResult.name };
                this.updateSource({ property: 'Data.Object.Document.Card.Addressee', value: addressee });
            }
            catch (ex)
            {
                console.log(ex);
            }
        },
        onAddresseeSelectChip(e) {
            let addressee = { ContractorType: 1, Id: e.value.workplaceId, IsEmployee: true, Name: e.value.name };
            this.updateSource({ property: 'Data.Object.Document.Card.Addressee', value: addressee });
        },
        onRemoveAddressee() {
            this.updateSource({ property: 'Data.Object.Document.Card.Addressee', value: null });
        },
        validateTemplate() {
            for (let req of this.document.Template.Requisites) {
                if (req.IsRequired && !req.Value)
                    return false;
            }

            return true;
        }
    },
    async created() {
        (async() => {
            while(typeof this.$refs.form === 'undefined')
                await new Promise(resolve => setTimeout(resolve, 100));

            this.$refs?.form?.[0]?.validate();
        })();
    },
    updated() {
        if(this.dataSource !== null){
            this.$refs?.form?.[0]?.validate();
        }  
    },
    mounted() {        
        this.$eventBus.$on('set-active-tab', async ({ FormId }) => {
            let page = this.pages.find(x => x.FormId === FormId);

            if (page) {
                let targetIndex = this.pages.indexOf(page);

                if (this.tab != targetIndex)
                    this.tab = targetIndex;
                else
                    this.$eventBus.$emit('update-active-tab');
            }
        });
    },
    beforeDestroy() {
        this.$eventBus.$off('set-active-tab');
    }
}
</script>